module.exports = __webpack_public_path__ + "video/2200-2_YR_2021_Spyware.f21cf6ad.vtt";